import { useState } from "react";
import { useContractorPackage } from "@hooks/crud/useContractorPackages";
import ContractorPackageModal from "@stories/organisms/ContractorPackageModal/ContractorPackageModal";
import { useProjectContext } from "@hooks/context/useProjectContext";
import { PageBreadcrumbs } from "@stories/atoms/PageBreadcrumbs/PageBreadcrumbs";
import * as RouteHelper from "@utils/routes";
import {
  ContractorPackageLineItem,
  createDefaultContractorPackage,
} from "@interfaces/contractorPackage";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { ProjectLoader } from "@stories/atoms/Loaders/ProjectLoader/ProjectLoader";
import { StyledCard } from "@stories/atoms/StyledCard/StyledCard";
import { StyledButton } from "@stories/atoms/StyledButton/StyledButton";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { ContractorPackageTable } from "@stories/organisms/Tables/ContractorPackageTable";
import { useProfileContext } from "@hooks/context/useProfileContext";

export const ContractorPackages = () => {
  const navigate = useNavigate();
  const { userOrganisation } = useProfileContext();
  const { selectedProject, selectedProjectOrganisation } = useProjectContext();
  const {
    isContractorPackageLoading,
    contractorPackages,
    createContractorPackage,
    updateContractorPackage,
    deleteContractorPackage,
  } = useContractorPackage(selectedProject.id);
  const [selectedPackage, setSelectedPackage] = useState<
    ContractorPackageLineItem | undefined
  >(undefined);

  // const { getAnalysis, isAnalysisLoading } = useAnalysis();

  const [editMode, setEditMode] = useState<boolean>(false);

  const handleClose = () => {
    setEditMode(false);
    setSelectedPackage(undefined);
  };
  const handleOpen = () => {
    setSelectedPackage(createDefaultContractorPackage(selectedProject));
  };

  const handleViewPackage = (contractorPackage: ContractorPackageLineItem) => {
    navigate(
      RouteHelper.contractorPackage(
        contractorPackage.projectId,
        contractorPackage.id
      )
    );
  };

  const handleEditPackage = (contractorPackage: ContractorPackageLineItem) => {
    setEditMode(true);
    setSelectedPackage(contractorPackage);
  };

  const handleReportDownload = (
    contractorPackage: ContractorPackageLineItem
  ) => {
    // getAnalysis(selectedProject.id);
  };

  const handleDeletePackage = (
    contractorPackage: ContractorPackageLineItem
  ) => {
    deleteContractorPackage(contractorPackage);
  };

  if (!selectedProject || !userOrganisation) {
    console.log("Sub contractor package PAGE LOADER");
    return <ProjectLoader />;
  }

  const breadcrumbs = [
    {
      path: RouteHelper.packages(selectedProject.id),
      name: `${selectedProject.projectName} Packages`,
    },
  ];

  contractorPackages.sort((a, b) => {
    if (a.contractorId !== b.contractorId) {
      return a.contractorId === userOrganisation.id ? -1 : 1;
    }
    return a.created.getTime() - b.created.getTime();
  });

  return (
    <>
      <PageBreadcrumbs
        title={`${selectedProject.projectName} Packages`}
        organisationLogo={selectedProjectOrganisation.organisationLogo}
        links={breadcrumbs}
      />
      <StyledCard>
        <Grid container spacing={2} sx={{ padding: "12px" }}>
          <Grid item xs={12} md={8}></Grid>
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              display: "flex",
              alignContent: "right",
              justifyContent: "right",

              padding: "12px 12px 0px 12px",
            }}
            justifyContent={"right"}
          >
            <StyledButton
              variant="contained"
              startIcon={<AddCircleIcon />}
              onClick={handleOpen}
            >
              Add Package
            </StyledButton>
          </Grid>
          <Grid item xs={12} md={12}>
            <ContractorPackageTable
              loading={isContractorPackageLoading}
              project={selectedProject}
              contractorPackages={contractorPackages}
              handleOpen={handleOpen}
              handleViewPackage={handleViewPackage}
              handleEditPackage={handleEditPackage}
              handleReportDownload={handleReportDownload}
              handleDeletePackage={handleDeletePackage}
            />
          </Grid>
        </Grid>
      </StyledCard>
      {selectedPackage ? (
        <ContractorPackageModal
          open={!!selectedPackage}
          editMode={editMode}
          loading={isContractorPackageLoading}
          handleClose={handleClose}
          project={selectedProject}
          createContractorPackage={createContractorPackage}
          updateContractorPackage={updateContractorPackage}
          existingContractorPackage={selectedPackage}
        />
      ) : null}
    </>
  );
};
